import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

import {socialMediaLogins} from "../../portfolio";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
    <Container>
    <blockquote class="twitter-tweet">
    <p lang="en" dir="ltr">
    📑Extracting the vocabulary you need 
    <br></br>
    Bored of learning a foreign language in a strict and riggid manner? I got something new coming up for y&#39;all!
    <br></br>
    Look and write in the comments if you want to suggest a language or getting access to it. Follow me for any updates^
    <a href="https://twitter.com/_buildspace?ref_src=twsrc%5Etfw">@_buildspace </a> <> - </>
    <a href="https://t.co/stluKVHlSb"> pic.twitter.com/stluKVHlSb</a>
    </p>
    &mdash; Andrea (Gigi) (@DatGigi) <a href="https://twitter.com/DatGigi/status/1650745110844325890?ref_src=twsrc%5Etfw">April 25, 2023</a>
    </blockquote> 
    </Container>
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I fell in love with programming, analzying, managing and I have at least learnt
              something, I think… 🤷‍♂️
              <br />
              <br />I am quite familiar with all the following technologies, always striving to learn more :)
              <i>
                <b className="purple"> and I am mainly working with Javascript and Python. </b>
              </i>
              <br />
              <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Data Science and IT-Management.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, I also apply my passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and also using Cloud Products/APIs</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          
        </Row>
      </Container>
      <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> 
    </Container>
  );
}
export default Home2;
